import React, {useState, useEffect} from 'react';
import {useHistory, useParams} from "react-router-dom";
import {withTranslation} from 'react-i18next';
import {ProgressBar} from 'primereact/progressbar';
import {Form, Field} from 'react-final-form';
import {Button} from "primereact/button";
import { SplitButton } from 'primereact/splitbutton';
import {Dropdown} from "primereact/dropdown";
import {InputText} from "primereact/inputtext";
import {classNames} from "primereact/utils";
import {addLocale} from "primereact/api";
import axios from "axios";

const MaterialFormComponent = (props) => {

  const {t} = props;
  const history = useHistory();
  const {entity, action, id} = useParams();
  const [loading, setLoading] = useState(false);
  const [formData, setFormData] = useState({});
  const [newFormData, setNewFormData] = useState({});
  const [manufacturers, setManufacturers] = useState([]);
  const [categories, setCategories] = useState([]);
  const [units, setUnits] = useState([]);
  const [groups, setGroups] = useState([]);
  const [currencies, setCurrencies] = useState([]);
  const [statusDict, setStatusDict] = useState([]);
  const materialId = window.App.urlVars().materialId ?? id;
  const [materialGeometryDict, setMaterialgeometryDict] = useState([]);
  const [showMaterialGeometry, setShowMaterialGeometry] = useState(false);

  const currentView = (window.App.urlVars().view || 'master').toLowerCase();

  const MATERIAL_GROUPS_BY_VIEW = {
    trading: ['TG'],
    production: ['RM', 'SFG', 'FG'],
    operations: ['MRO', 'SUPPLY'],
  };

  const allowedMaterialGroupKeys = MATERIAL_GROUPS_BY_VIEW[currentView] || null;

  const allowedGroups = allowedMaterialGroupKeys
    ? groups.filter(group => allowedMaterialGroupKeys.includes(group.key))
    : groups;

  const showMaterialGroupSelect = allowedGroups.length > 1;

  const defaultMaterialGroup =
    allowedGroups.length === 1
      ? allowedGroups[0].key
      : null;

  const validate = (data) => {
    let errors = {};
    // if (!data.company) {
    //   errors.company = 'Kötelező mező';
    // }
    // if (!data.partner) {
    //   errors.partner = 'Kötelező mező';
    // }
    return errors;
  };

  const getAllowedNextStatuses = (currentStatus) => {
    switch (currentStatus) {
      case 'ACTIVE':
        return ['PHASE_OUT'];
      case 'PHASE_OUT':
        return ['ACTIVE', 'OBSOLETE'];
      case 'OBSOLETE':
        return ['ACTIVE'];
      default:
        return [];
    }
  };


  const onSubmit = (data, form) => {
    setLoading(true)
    const payload = {
      ...data,
      ...newFormData,
    };
    if (!payload.material_group && defaultMaterialGroup) {
      payload.material_group = defaultMaterialGroup;
    }
    if ((window.App.urlVars().materialId) || (entity === 'material' && id)) {
      apiCall('patch', '/api/v2/material/' + (window.App.urlVars().materialId ?? id), payload)
        .then(response => {
          window.App.toastShow('success', 'Sikeres mentés!');
          window.App.setState({rerenderMaterialList: Math.random()})
          if (props.goback === true) {
            history.push(props.backlink);
          }
        })
        .catch(error => {
          window.App.toastShow('error', t('error'), error.toString(), '', error.response);
        })
        .finally(() => {
          setLoading(false);
        })
    } else {
      apiCall('post', '/api/v2/material', payload)
        .then(response => {
          const newId = response.data.data.id;
          window.App.toastShow('success', 'Sikeres mentés!');
          // window.App.setState({ rerenderMaterialList: Math.random() });
          window.App.setState({ rerenderMaterialList: Math.random() });
          if (props.goback === true) {
            history.push(props.backlink + (history.location.search || ''));
          } else {
            const current = new URLSearchParams(history.location.search || '');
            if (!current.get('view')) current.set('view', currentView || 'master');
            current.set('materialId', String(newId));
            history.push(`/inventory/material/update/${newId}?${current.toString()}`);
          }
        })
        .catch(error => {
          window.App.toastShow('error', t('error'), error.toString(), '', error.response);
        })
        .finally(() => {
          setLoading(false);
        })
    }
  };

  const isFormFieldValid = (meta) => !!(meta.touched && meta.error);
  const getFormErrorMessage = (meta) => {
    return isFormFieldValid(meta) && <small className="p-error">{meta.error}</small>;
  };

  addLocale('hu', {
    firstDayOfWeek: 1,
    dayNames: ['vasárnap', 'hétfő', 'kedd', 'szerda', 'csütörtök', 'péntek', 'szombat'],
    dayNamesShort: ['vas', 'hé', 'ke', 'sze', 'csü', 'pé', 'szo'],
    dayNamesMin: ['V', 'H', 'K', 'SZ', 'CS', 'P', 'SZ'],
    monthNames: ['január', 'február', 'március', 'április', 'május', 'június', 'július', 'augusztus', 'szeptember',
      'október', 'november', 'december'],
    monthNamesShort: ['jan', 'feb', 'mar', 'ápr', 'máj', 'jun', 'júl', 'aug', 'szep', 'okt', 'nov', 'dec'],
    today: 'Ma',
    clear: 'Töröl'
  });

  const apiCall = (method, url, data) => {
    return axios({
      method: method,
      url: process.env.REACT_APP_API_HOST + url,
      data,
      params: {},
      headers: {
        'Authorization': 'Bearer ' + localStorage.getItem("userToken"),
        'App-Network': localStorage.getItem("networkId")
      }
    })
  }
  // const toolbarOptions = {
  //   container: [
  //     [{'header': [1, 2, 3, 4, 5, 6, false]}],
  //     ['bold', 'italic', 'underline', 'strike'],
  //     ['image', 'formula'],
  //     [{'align': []}],

  //     [{'list': 'ordered'}, {'list': 'bullet'}, {'list': 'check'}],
  //     [{'script': 'sub'}, {'script': 'super'}],
  //     [{'indent': '-1'}, {'indent': '+1'}],
  //     [{'color': []}, {'background': []}],
  //     ['clean']
  //   ]
  // }


  const splitButtonModel = () => {
    if (!formData?.status) return [];
    const allowedTargets = getAllowedNextStatuses(formData.status);
    return allowedTargets.map(st => {
      const dictItem = statusDict.find(d => d.key === st);
      return {
        label: dictItem ? dictItem.value : st,
        command: () => {
          setLoading(true);
          apiCall('patch', '/api/v2/material/' + (window.App.urlVars().materialId ?? id), {
            status: st
          })
            .then(response => {
              window.App.toastShow('success', 'Sikeres módosítás', response.data.message);
              setFormData(response.data.data);
            })
            .catch(error => {
              window.App.toastShow('error', t('error'), error.toString(), '', error.response);
            })
            .finally(() => {
              setLoading(false);
            });
        }
      }
    });
  };

  const currentStatusLabel = () => {
    if (!formData?.status) return '';
    const found = statusDict.find(d => d.key === formData.status);
    return found ? found.value : formData.status;
  };



  useEffect(() => {
    apiCall('get', '/api/v2/manufacturer?limit=1000')
      .then(response => {
        setManufacturers(response.data.data.items)
      })
      .catch(error => {
        window.App.toastShow('error', t('error'), error.toString(), '', error.response);
      })
    apiCall('get', '/api/v2/material-category')
      .then(response => {
        setCategories(response.data.data.items)
      })
      .catch(error => {
        window.App.toastShow('error', t('error'), error.toString(), '', error.response);
      })
    apiCall('get', '/api/v2/dictionary/material-geometry')
      .then(response => {
        setMaterialgeometryDict(response.data.data || []);
      })
      .catch(error => {
        window.App.toastShow('error', t('error'), error.toString(), '', error.response);
      });
    apiCall('get', '/api/v2/unit?search[procurement][operator]==&search[procurement][value]=true')
      .then(response => {
        setUnits(response.data.data.items)
      })
      .catch(error => {
        window.App.toastShow('error', t('error'), error.toString(), '', error.response);
      })
    apiCall('get', '/api/v2/dictionary/material-group')
      .then(response => {
        setGroups(response.data.data)
      })
      .catch(error => {
        window.App.toastShow('error', t('error'), error.toString(), '', error.response);
      })
    apiCall('get', '/api/v2/dictionary/material-status')
      .then(response => {
        setStatusDict(response.data.data || []);
      })
      .catch(error => {
        window.App.toastShow('error', t('error'), error.toString(), '', error.response);
      });
    apiCall('GET', '/api/v2/dictionary/currency')
      .then(response => {
        setCurrencies(response.data.data)
      })
      .catch(error => {
        window.App.toastShow('error', t('error'), error.toString(), '', error.response);
      })
    if ((!window.App.urlVars().create && window.App.urlVars().materialId) || (entity === 'material' && id)) {
      setLoading(true);
      apiCall('get', '/api/v2/material/' + (window.App.urlVars().materialId ?? id))
        .then(response => {
          setFormData(response.data.data)
        })
        .catch(error => {
          window.App.toastShow('error', t('error'), error.toString(), '', error.response);
        })
        .finally(() => {
          setLoading(false);
        })
    }
  }, [materialId])

  useEffect(() => {
    const isCreate =
      window.App.urlVars().create ||
      (entity === 'material' && action === 'create') ||
      (!id && !window.App.urlVars().materialId);
    if (!isCreate || !allowedGroups?.length || formData.material_group) {
      return;
    }
    if (allowedGroups.length === 1) {
      setFormData(prev => ({
        ...prev,
        material_group: allowedGroups[0].key
      }));
      setNewFormData(prev => ({
        ...prev,
        material_group: allowedGroups[0].key
      }));
    }
  }, [allowedGroups, formData.material_group, entity, action, id]);

  useEffect(() => {
    const selectedId = formData.category?.id || formData.category;
    if (!selectedId || !categories?.length) {
      setShowMaterialGeometry(false);
      return;
    }
    const selectedCategory = categories.find(c => String(c.id) === String(selectedId));
    const shouldShow = !!(selectedCategory && selectedCategory.value_material_geometry && selectedCategory.value_material_geometry !== 'disabled');
    setShowMaterialGeometry(shouldShow);
    if (!shouldShow && formData.material_geometry) {
      setFormData(prev => ({ ...prev, material_geometry: null }));
      setNewFormData(prev => ({ ...prev, material_geometry: null }));
    }
  }, [formData.category, categories]);

  useEffect(() => {
    if (!(action === 'update') && currencies?.length && !formData.currency) {
      setFormData(prev => ({ ...prev, currency: process.env.REACT_APP_CURRENCY_DEFAULT }));
      setNewFormData(prev => ({ ...prev, currency: process.env.REACT_APP_CURRENCY_DEFAULT }));
    }
  }, [currencies, entity, id, formData.currency]);

  return (
    <div className={"material-form widget"}>
      {loading &&
        <ProgressBar mode="indeterminate"
                     style={{height: '5px', position: "absolute", top: 0, left: 0, borderRadius: 0,}}></ProgressBar>
      }
      <Form onSubmit={onSubmit} initialValues={formData}
            validate={validate} render={({handleSubmit, submitting}) => (
        <form onSubmit={handleSubmit} className="">
          <div className={"p-grid"}>
            <div className={"p-col-12 p-lg-8"}>
              <Field name="name" render={({input, meta}) => (
                <div className="p-field p-fluid">
                  <label htmlFor="name"
                         className={classNames({'p-error': isFormFieldValid(meta)})}>{props.t('fieldName')}</label>
                  <span className="p-d-block">
                      <InputText id="name" {...input}
                                 onChange={(e) => {
                                   setFormData({
                                     ...formData,
                                     name: e.target.value
                                   })
                                   setNewFormData({
                                     ...newFormData,
                                     name: e.target.value
                                   })
                                 }}
                                 value={formData.name}
                                 className={classNames({'p-invalid': isFormFieldValid(meta)})}/>
                    </span>
                  {getFormErrorMessage(meta)}
                </div>
              )}/>
            </div>
            <div className={"p-col-12 p-lg-4"}>
              <Field name="manufacturer" render={({input, meta}) => (
                <div className="p-field p-fluid">
                  <label htmlFor="manufacturer"
                         className={classNames({'p-error': isFormFieldValid(meta)})}>{props.t('fieldManufacturer')}</label>
                  <span className="p-d-block">
                      <Dropdown {...input}
                                onChange={(e) => {
                                  setFormData({
                                    ...formData,
                                    manufacturer: e.target.value
                                  })
                                  setNewFormData({
                                    ...newFormData,
                                    manufacturer: e.target.value
                                  })
                                }}
                                value={formData.manufacturer?.id || formData.manufacturer}
                                options={window.App.sortDropdownOptions(manufacturers, "name")}
                                filter
                                optionLabel="name"
                                optionValue="id"
                                id={"manufacturer"}
                                emptyMessage={t('noManufacturerYet')}
                                className={classNames({'p-error': isFormFieldValid(meta)})}
                      />
                    </span>
                  {getFormErrorMessage(meta)}
                </div>
              )}/>
            </div>
            <div className={"p-col-12 p-lg-4"}>
              <Field name="upc" render={({input, meta}) => (
                <div className="p-field p-fluid">
                  <label htmlFor="upc"
                         className={classNames({'p-error': isFormFieldValid(meta)})}>{props.t('upc')}</label>
                  <span className="p-d-block">
                      <InputText id="upc" {...input}
                                 onChange={(e) => {
                                   setFormData({
                                     ...formData,
                                     upc: e.target.value
                                   })
                                   setNewFormData({
                                     ...newFormData,
                                     upc: e.target.value
                                   })
                                 }}
                                 value={formData.upc}
                                 className={classNames({'p-invalid': isFormFieldValid(meta)})}/>
                    </span>
                  {getFormErrorMessage(meta)}
                </div>
              )}/>
            </div>
            {showMaterialGroupSelect && (
              <div className={"p-col-12 p-lg-4"}>
                <Field name="material_group" render={({input, meta}) => (
                  <div className="p-field p-fluid">
                    <label
                      htmlFor="material_group"
                      className={classNames({'p-error': isFormFieldValid(meta)})}
                    >{props.t('fieldProductGroup')}</label>
                    <span className="p-d-block">
                      <Dropdown
                        {...input}
                        id="material_group"
                        value={formData.material_group?.key || formData.material_group}
                        options={window.App.sortDropdownOptions(allowedGroups, "value")}
                        optionLabel="value"
                        optionValue="key"
                        placeholder={t('selectProductGroupPlaceholder')}
                        onChange={(e) => {
                          setFormData({
                            ...formData,
                            material_group: e.value
                          });
                          setNewFormData({
                            ...newFormData,
                            material_group: e.value
                          });
                          input.onChange(e.value);
                        }}
                        className={classNames({'p-invalid': isFormFieldValid(meta)})}
                      />
                    </span>
                    {getFormErrorMessage(meta)}
                  </div>
                )}/>
              </div>
            )}
            {/*<div className={"p-col-12 p-lg-4"}>*/}
            {/*  <Field name="material_group" render={({input, meta}) => (*/}
            {/*    <div className="p-field p-fluid">*/}
            {/*      <label htmlFor="material_group"*/}
            {/*             className={classNames({'p-error': isFormFieldValid(meta)})}>{props.t('fieldMaterialGroup')}</label>*/}
            {/*       <div className="p-d-block">*/}
            {/*          {groups?.map((group) => (*/}
            {/*            <div key={group.key} className="p-field-radiobutton">*/}
            {/*              <input*/}
            {/*                id={`material_group_${group.key}`}*/}
            {/*                type="radio"*/}
            {/*                name="material_group"*/}
            {/*                value={group.key}*/}
            {/*                checked={(formData.material_group ?? input.value) === group.key}*/}
            {/*                onChange={(e) => {*/}
            {/*                  const v = e.target.value;*/}
            {/*                  setFormData(prev => ({ ...prev, material_group: v }));*/}
            {/*                  setNewFormData(prev => ({ ...prev, material_group: v }));*/}
            {/*                  input.onChange(v);*/}
            {/*                }}*/}
            {/*              />*/}
            {/*              <label htmlFor={`material_group_${group.key}`}>{group.value}</label>*/}
            {/*            </div>*/}
            {/*          ))}*/}
            {/*        </div>*/}
            {/*      {getFormErrorMessage(meta)}*/}
            {/*    </div>*/}
            {/*  )}/>*/}
            {/*</div>*/}
            <div className={"p-col-12 p-lg-4"}>
              <Field name="category" render={({input, meta}) => (
                <div className="p-field p-fluid">
                  <label htmlFor="category"
                         className={classNames({'p-error': isFormFieldValid(meta)})}>{props.t('fieldCategory')}</label>
                  <span className="p-d-block">
                      <Dropdown {...input}
                                onChange={(e) => {
                                  setFormData({
                                    ...formData,
                                    category: e.target.value
                                  })
                                  setNewFormData({
                                    ...newFormData,
                                    category: e.target.value
                                  })
                                }}
                                value={formData.category?.id || formData.category}
                                options={window.App.sortDropdownOptions(categories, "name")}
                                optionLabel="name"
                                optionValue="id"
                                filter
                                id={"category"}
                                emptyMessage={t('noCategoryYet')}
                                className={classNames({'p-error': isFormFieldValid(meta)})}
                      />
                    </span>
                  {getFormErrorMessage(meta)}
                </div>
              )}/>
            </div>
            {showMaterialGeometry &&
              <div className={"p-col-12 p-lg-4"}>
                <Field name="material_geometry" render={({input, meta}) => (
                  <div className="p-field p-fluid">
                    <label htmlFor="material_geometry"
                           className={classNames({'p-error': isFormFieldValid(meta)})}>{props.t('fieldMaterialGeometry')}</label>
                    <span className="p-d-block">
                      <Dropdown {...input}
                                onChange={(e) => {
                                  setFormData({
                                    ...formData,
                                    material_geometry: e.target.value
                                  })
                                  setNewFormData({
                                    ...newFormData,
                                    material_geometry: e.target.value
                                  })
                                }}
                                value={formData.material_geometry?.id || formData.material_geometry}
                                options={window.App.sortDropdownOptions(materialGeometryDict, "value")}
                                optionLabel="value"
                                optionValue="key"
                                filter
                                id={"material_geometry"}
                                emptyMessage={t('noElementYet')}
                                className={classNames({'p-error': isFormFieldValid(meta)})}
                      />
                    </span>
                    {getFormErrorMessage(meta)}
                  </div>
                )}/>
              </div>
            }
            <div className={"p-col-12 p-lg-4"}>
              <Field name="unit" render={({input, meta}) => (
                <div className="p-field p-fluid">
                  <label htmlFor="unit"
                         className={classNames({'p-error': isFormFieldValid(meta)})}>{props.t('fieldUnit')}</label>
                  <span className="p-d-block">
                      <Dropdown {...input}
                                onChange={(e) => {
                                  setFormData({
                                    ...formData,
                                    unit: e.target.value
                                  })
                                  setNewFormData({
                                    ...newFormData,
                                    unit: e.target.value
                                  })
                                }}
                                value={formData.unit?.id || formData.unit}
                                options={window.App.sortDropdownOptions(units, "name")}
                                optionLabel="name"
                                optionValue="id"
                                filter
                                id={"unit"}
                                emptyMessage={t('noUnitYet')}
                                className={classNames({'p-error': isFormFieldValid(meta)})}
                      />
                    </span>
                  {getFormErrorMessage(meta)}
                </div>
              )}/>
            </div>

            <div className={"p-col-12 p-lg-12"}>
              <Field name="description" render={({input, meta}) => (
                <div className="p-field p-fluid">
                  <label htmlFor="description"
                         className={classNames({'p-error': isFormFieldValid(meta)})}>{props.t('fieldDescription')}</label>
                  <span className="p-d-block">
                      <InputText id="description" {...input}
                                 onChange={(e) => {
                                   setFormData({
                                     ...formData,
                                     description: e.target.value
                                   })
                                   setNewFormData({
                                     ...newFormData,
                                     description: e.target.value
                                   })
                                 }}
                                 value={formData.description}
                                 className={classNames({'p-invalid': isFormFieldValid(meta)})}/>
                    </span>
                  {getFormErrorMessage(meta)}
                </div>
              )}/>
            </div>
            {/*<div className={"p-col-12 p-lg-5"}>*/}
            {/*  <Field name="sku" render={({input, meta}) => (*/}
            {/*    <div className="p-field p-fluid">*/}
            {/*      <label htmlFor="sku"*/}
            {/*             className={classNames({'p-error': isFormFieldValid(meta)})}>{props.t('fieldSku')}</label>*/}
            {/*      <span className="p-d-block">*/}
            {/*          <InputText id="sku" {...input}*/}
            {/*                     onChange={(e) => {*/}
            {/*                       setFormData({*/}
            {/*                         ...formData,*/}
            {/*                         sku: e.target.value*/}
            {/*                       })*/}
            {/*                       setNewFormData({*/}
            {/*                         ...newFormData,*/}
            {/*                         sku: e.target.value*/}
            {/*                       })*/}
            {/*                     }}*/}
            {/*                     value={formData.sku}*/}
            {/*                     className={classNames({'p-invalid': isFormFieldValid(meta)})}/>*/}
            {/*        </span>*/}
            {/*      {getFormErrorMessage(meta)}*/}
            {/*    </div>*/}
            {/*  )}/>*/}
            {/*</div>*/}
            {/*<div className={"p-col-12 p-lg-5"}>*/}
            {/*  <Field name="avg_purchase_price" render={({input, meta}) => (*/}
            {/*    <div className="p-field p-fluid">*/}
            {/*      <label htmlFor="avg_purchase_price"*/}
            {/*             className={classNames({'p-error': isFormFieldValid(meta)})}>{props.t('fieldAvgPurchasePrice')}</label>*/}
            {/*      <span className="p-d-block">*/}
            {/*          <InputNumber id="avg_purchase_price" {...input}*/}
            {/*                       onChange={(e) => {*/}
            {/*                         setFormData({*/}
            {/*                           ...formData,*/}
            {/*                           avg_purchase_price: e.value*/}
            {/*                         })*/}
            {/*                       }}*/}
            {/*                       value={formData.avg_purchase_price}*/}
            {/*                       className={classNames({'p-invalid': isFormFieldValid(meta)})}/>*/}
            {/*        </span>*/}
            {/*      {getFormErrorMessage(meta)}*/}
            {/*    </div>*/}
            {/*  )}/>*/}
            {/*</div>*/}
            {/*<div className={"p-col-12 p-lg-5"}>*/}
            {/*  <Field name="last_purchase_price" render={({input, meta}) => (*/}
            {/*    <div className="p-field p-fluid">*/}
            {/*      <label htmlFor="last_purchase_price"*/}
            {/*             className={classNames({'p-error': isFormFieldValid(meta)})}>{props.t('fieldLastPurchasePrice')}</label>*/}
            {/*      <span className="p-d-block">*/}
            {/*          <InputNumber id="last_purchase_price" {...input}*/}
            {/*                       onChange={(e) => {*/}
            {/*                         setFormData({*/}
            {/*                           ...formData,*/}
            {/*                           last_purchase_price: e.value*/}
            {/*                         })*/}
            {/*                       }}*/}
            {/*                       value={formData.last_purchase_price}*/}
            {/*                       className={classNames({'p-invalid': isFormFieldValid(meta)})}/>*/}
            {/*        </span>*/}
            {/*      {getFormErrorMessage(meta)}*/}
            {/*    </div>*/}
            {/*  )}/>*/}
            {/*</div>*/}
            {/*<div className={"p-col-12 p-lg-2"}>*/}
            {/*  <Field name="currency" render={({input, meta}) => (*/}
            {/*    <div className="p-field p-fluid">*/}
            {/*      <label htmlFor="currency"*/}
            {/*             className={classNames({'p-error': isFormFieldValid(meta)})}>{props.t('fieldCurrency')}</label>*/}
            {/*      <span className={"p-d-block"}>*/}
            {/*                  <Dropdown {...input}*/}
            {/*                            onChange={(e) => {*/}
            {/*                              setFormData({*/}
            {/*                                ...formData,*/}
            {/*                                currency: e.target.value*/}
            {/*                              })*/}
            {/*                              setNewFormData({*/}
            {/*                                ...newFormData,*/}
            {/*                                currency: e.target.value*/}
            {/*                              })*/}
            {/*                            }}*/}
            {/*                            value={formData.currency}*/}
            {/*                            options={window.App.sortDropdownOptions(currencies, "code")}*/}
            {/*                            optionLabel="code"*/}
            {/*                            optionValue="code"*/}
            {/*                            id={"currency"}*/}
            {/*                            emptyMessage={t('noCurrencyYet')}*/}
            {/*                            className={classNames({'p-error': isFormFieldValid(meta)})}*/}
            {/*                  />*/}
            {/*                </span>*/}
            {/*      {getFormErrorMessage(meta)}*/}
            {/*    </div>*/}
            {/*  )}/>*/}
            {/*</div>*/}
          </div>
          <div className={"p-grid p-mt-1"}>
            <div className={"p-col-12 p-lg-6 p-xl-6"}>
                <SplitButton
                  type="button"
                  id="materialStatusButton"
                  label={currentStatusLabel()}
                  icon="pi pi-info-circle"
                  className="p-button-warning"
                  loading={loading}
                  disabled={!materialId}
                  onClick={() => {
                    document
                      .getElementById('materialStatusButton')
                      .getElementsByClassName('p-splitbutton-menubutton')[0]
                      .click();
                  }}
                  model={splitButtonModel()}
                />
            </div>
            <div className={"p-col-12 p-lg-6 p-xl-6 p-text-right p-col-align-center"}>
              {entity === 'material' &&
                <Button type="submit" label={t('save')}
                        loading={loading}
                        icon={"pi pi-save"}
                        className="p-button-success p-ml-2"/>
              }
              <Button type="submit" label={t('saveAndBack')}
                      onClick={() => {
                        props = {...props, goback: true}
                      }}
                      loading={loading}
                      icon={"pi pi-arrow-left"}
                      className="p-button-success p-ml-2"/>
            </div>
          </div>
        </form>
      )}/>
    </div>
  )
}
export default withTranslation('common')(MaterialFormComponent);
